import { Observable } from 'rxjs';
import { InstructionRequest, InstructionResponse } from '@src/core/domain/query/query.model';

export abstract class InstructionRepository {
  abstract getInstruction(params: InstructionRequest): Observable<InstructionResponse>;  
}